import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useStateContext } from "../context/ContextProvider";
import {
  IoCashOutline,
  IoChatbubbleEllipsesOutline,
  IoHome,
  IoHeart,
  IoPerson,
  IoCartOutline,
  IoHeartOutline,
  IoCallOutline,
  IoSearch,
  IoLogoFacebook,
  IoLogoInstagram,
  IoLogoYoutube,
  IoLogoWhatsapp,
  IoLogoTiktok,
  IoLogoLinkedin,
  IoLogoTwitter,
  IoNavigateCircle,
  IoApps,
  IoClose,
  IoCaretDownOutline,
  IoCaretForward,
  IoMenu,
  IoShareSocialSharp,
  IoInformationCircleOutline,
  IoWalletOutline,
  IoSwapHorizontal,
  IoPersonOutline,
  IoMailSharp,
  IoMailOpenOutline,
  IoCall 
} from "react-icons/io5";
import "../styles/Footer.css";

const Footer = () => {
  const { lang } = useStateContext();
  const FooterLogoUrl = process.env.PUBLIC_URL + "/images/logo.webp";
  const [menuData, setMenuData] = useState({});

  useEffect(() => {
    fetch(
      `${process.env.REACT_APP_ADMIN_URL}/api/Menu/get-all-menus-by-type?menuTypeId=3`
    )
      .then((response) => response.json())
      .then((data) => setMenuData(data.data));
  }, []);

  return (
    <>
      {/* Footer */}

      <footer className="footer_n pt-4 pb-3">
        <div className="footer-bottom_n">
          <div className="container">
            <div className="inner-content">
              <div className="row align-items-center">
                <div className="col-lg-4 col-12 text-center text-lg-start">
                  <h4 className="" style={{ color: "#FFD700" }}>
                    Əlaqə
                  </h4>
                  <div className="d-flex flex-column align-items-center align-items-lg-start gap-2 mb-3">
                    <a
                      className="text-light mt-2 d-flex align-items-center justify-content-center justify-content-lg-start gap-1"
                      href="tel:0124540010"
                      style={{ textDecoration: "none" }}
                    >
                      <IoCallOutline className="fs-3" />
                      <h4 className="phone-number m-0">0124540010</h4>
                    </a>
                    <a href="#" style={{ color: "#FFD700", fontSize: "14px" }}>
                      Zeng Sifariş Et
                    </a>
                  </div>
                </div>
                <div className="col-lg-4 col-12 d-flex flex-column align-items-center align-items-lg-center justify-content-start gap-3 mb-3 text-center">
                  <a
                    className="footer-mail-link d-flex align-items-center justify-content-center gap-2 text-light"
                    href="mailto:dosttech2026@gmail.com"
                    style={{ textDecoration: "none" }}
                  >
                    <IoMailOpenOutline />
                    <span className="footer-email">dosttech2026@gmail.com</span>
                  </a>
                  <a
                    className="d-flex align-items-center justify-content-center gap-2 text-light"
                    href="tel:+994772551221"
                    style={{ textDecoration: "none" }}
                  >
                    <IoCall />
                    <span className="phone-number">+994772551221</span>
                  </a>
                </div>
                <div className="col-lg-4 col-12 text-center text-lg-end">
                  <nav
                    className="footer-legal-nav d-flex flex-column align-items-center align-items-lg-end gap-2"
                    aria-label="Hüquqi sənədlər"
                  >
                    <Link
                      to={`/${lang || "az"}/qanunvericilik`}
                      className="footer-legal-nav-link"
                    >
                      Qanunvericilik
                    </Link>
                    <Link
                      to={`/${lang || "az"}/mxfilik-siyaseti`}
                      className="footer-legal-nav-link"
                    >
                      Məxfilik siyasəti
                    </Link>
                    <Link
                      to={`/${lang || "az"}/saytdan-istifade-sertleri`}
                      className="footer-legal-nav-link"
                    >
                      Saytdan istifadə şərtləri
                    </Link>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-legal-bar">
          <div className="container">
            <p className="footer-legal-text text-center mb-0 py-3">
              Dosttech © {new Date().getFullYear()}. Bütün hüquqlar qorunur.
              <span className="footer-legal-sep" aria-hidden="true">
                {"\u00A0·\u00A0"}
              </span>
              <a
                href="https://fraktal.az/"
                rel="nofollow noopener noreferrer"
                target="_blank"
                className="footer-legal-fraktal"
              >
                fraktal
              </a>
            </p>
          </div>
        </div>
      </footer>

      <div className="footer-cards_n">
        {/*}
        <img
          className="footer-card_n"
          src="https://static.dosttech.az/2/card_types/worldkart.png"
          alt="Card 1"
        />*/}
        <img
          className="footer-card_n"
          src="https://static.dosttech.az/2/card_types/visa.png"
          alt="Card 2"
        />
        <img
          className="footer-card_n"
          src="https://static.dosttech.az/2/card_types/tamkart.png"
          alt="Card 3"
        />
        <img
          className="footer-card_n"
          src="https://static.dosttech.az/2/card_types/mastercard.gif"
          alt="Card 4"
        />
        <img
          className="footer-card_n"
          src="https://static.dosttech.az/2/card_types/jcb_logo.png"
          alt="Card 5"
        />
        {/*}
        <img
          className="footer-card_n"
          src="https://static.dosttech.az/2/card_types/bolkart.png"
          alt="Card 6"
        />{*/}
        {/*
        <img
          className="footer-card_n"
          src="https://static.dosttech.az/2/card_types/birkart.png"
          alt="Card 7"
        />*/}
        {/*}
        <img
          className="footer-card_n"
          src="https://static.dosttech.az/2/card_types/albali.jpg"
          alt="Card 8"
        />*/}
        {/*}<img
          className="footer-card_n"
          src="https://static.dosttech.az/2/card_types/worldkart.png"
          alt="Card 9"
        />{*/}
      </div>
      {/* End Footer */}
    </>
  );
};

export default Footer;
